export default __webpack_public_path__ + "chevron_right.96a800a983633d310f349fe6529b459d.png";